import { DefaultTheme } from 'styled-components';

export const demandStatusValues = {
  canceled: 'CANCELADO',
  ongoing: 'EM_CURSO',
  finished: 'FINALIZADO',
  notStarted: 'NAO_INICIADO',
  pending: 'PENDENTE',
  toCancel: 'CANCELAMENTO',
};

export const demandStatusLabels = {
  [demandStatusValues.canceled]: 'Cancelado',
  [demandStatusValues.ongoing]: 'Em Curso',
  [demandStatusValues.finished]: 'Finalizado',
  [demandStatusValues.notStarted]: 'Não iniciado',
  [demandStatusValues.pending]: 'Pendente',
  [demandStatusValues.toCancel]: 'Cancelamento',
};

export const demandStatusVariant: Record<string, keyof DefaultTheme['statusTag']> = {
  [demandStatusValues.canceled]: 'danger',
  [demandStatusValues.ongoing]: 'info',
  [demandStatusValues.finished]: 'accept',
  [demandStatusValues.notStarted]: 'notDefined',
  [demandStatusValues.pending]: 'warn',
  [demandStatusValues.toCancel]: 'moderate',
};
